import {useDispatch} from 'react-redux'
import {AppActions} from 'store/modules/app/actions'

export const useNotification = () => {
  const dispatchToStore = useDispatch()

  return args => {
    dispatchToStore(AppActions.notify(args))
  }
}
